export default __webpack_public_path__ + "static/media/ipaymy_splash_screen.66c4457d.gif";